<template>
  <div>
    <div class="details-banner top">
      <div class="details-intro">
        <el-row>
          <el-col :span="24">
            <div class="title">{{ detail.productTitle }}</div>
          </el-col>
          <el-col :xs="24" :md="18">
            <div class="subtitle">{{ detail.productIntroduction }}</div>
          </el-col>
          <el-col :xs="24" :md="6">
            <!-- <div class="subtitle">{{ detail.productionCompany }}<br />{{ detail.contactEmail }}</div> -->
          </el-col>
          <el-col :xs="24" :md="12" style="margin-top: 40px">
            <el-row :gutter="20">
              <el-col
                :xs="12"
                :lg="8"
                :xl="6"
                style="margin-bottom: 10px; width: 136px"
              >
                <div
                  class="btn text-white"
                  @click="
                    () => {
                      open = true;
                      title = detail.productTitle;
                    }
                  "
                >
                  产品咨询
                </div>
              </el-col>
              <el-col :xs="12" :lg="8" :xl="6" style="padding-left: 16px">
                <!-- <div class="btn1" @click="toSystem(detail.systemLink)">进入系统</div>
                <div class="btn1">进入系统 <i style="margin-left: 8px;" class="el-icon-arrow-down"></i></div> -->
                <!-- <ul
                  class="inbutton"
                  :class="mousein ? 'inmouse' : ''"
                  @mouseover="inMouse"
                  @mouseout="outMouse"
                  v-if="
                    detail.linkStatus == '1' &&
                    detail.systemLinkData !== null &&
                    detail.systemLinkData.length > 1
                  "
                >
                  <li class="btn1">
                    立即使用
                    <i style="margin-left: 8px" class="el-icon-arrow-down"></i>
                  </li>
                  <li
                    v-for="(item, index) in detail.systemLinkData"
                    :key="index"
                    @click="toSystem(item.url)"
                  >
                    {{ item.name }}
                  </li>
                </ul> -->
                <div
                  v-if="
                    detail.linkStatus == '1' &&
                    detail.systemLinkData !== null &&
                    detail.systemLink !== '[]' &&
                    detail.systemLink !== 'null' &&
                    detail.systemLinkData
                  "
                  class="btn1"
                  @click="toSystem(detail.systemLinkData[0].url)"
                >
                  立即使用
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <!--      <img :src="detail.backgroundImage" style="width: 100%; height: 100%">-->
    </div>
    <div class="details-container" style="margin-bottom: 50px">
      <div class="contant">
        <div class="list" :class="{'fixed': isNavFixed}">
          <div class="tabItem" style="text-align: center;background-color: #fff;">
            <div
              v-for="(item, index) in titlelists"
              :key="index"
              style="
                font-weight: 500;
                padding: 0 20px;
                cursor: pointer;
                color: #000;
                display: inline-block;
                font-size: 16px;
              "
            >
              <div
                :class="{ active: typeActive == index }"
                style="padding: 15px 0px"
                @click="changeTypeActive(index, item)"
              >
                {{ item }}
              </div>
              <!-- <div
                v-show="typeActive == index"
                style="border-bottom: 2px solid #d7000f"
              >
                <div style="width: 100%"></div>
              </div> -->
            </div>
          </div>
        </div>
        <div
          class="item"
          v-for="(item, index) in detail.infoList"
          :key="index"
          v-if="item.moduleStatus === '1'"
        >
          <div
            class="contant-title"
            v-if="detail.infoList && item.moduleName !== '自定义模块'"
          >
            <span></span>
            <span>{{ item.moduleTitle }}</span>
          </div>
          <el-row :gutter="20" :id="`iddtail${item.moduleTitle}`">
            <!-- 痛点模块 -->
            <div
              v-if="item.moduleName === '痛点模块'"
              :id="`iddtail${item.moduleTitle}`"
            >
              <el-col
                v-for="(v, i) in item.contentList"
                :key="v.id"
                :xs="24"
                :sm="8"
                :lg="6"
              >
                <div class="box">
                  <img
                    style="width: 68px; height: 68px"
                    :src="`/static/img/jjfa/${i + 1}.png`"
                  />
                  <!-- <div class="label hidden-1">
                    {{ v.subtitle || i + 1 > 9 ? i + 1 : "0" + (i + 1) }}
                  </div> -->
                  <div class="desc hidden-3">{{ v.introduction }}</div>
                </div>
              </el-col>
            </div>
            <!-- 案例模块 -->
            <div
              v-if="item.moduleName === '案例模块'"
              :id="`iddtail${item.moduleTitle}`"
            >
              <el-col class="dxal-box" :xs="24" :sm="8" :lg="6">
                <div
                  v-if="detail.infoList[3].contentList[0]"
                  class="box"
                  @click="toPage(detail.infoList[3].contentList[0])"
                >
                  <div style="width: 100%; height: 100%">
                    <img :src="caseone && caseone.caseCover || ''" alt="" />
                  </div>
                  <div class="dxal-title">{{ caseone && caseone.caseTitle || '' }}</div>
                </div>
                <div
                  v-if="detail.infoList[3].contentList[1]"
                  class="box"
                  @click="toPage(detail.infoList[3].contentList[1])"
                >
                  <div style="width: 100%; height: 100%">
                    <img :src="casetwo && casetwo.caseCover || ''" alt="" />
                  </div>
                  <div class="dxal-title">{{casetwo && casetwo.caseTitle || '' }}</div>
                </div>
                <div
                  v-if="detail.infoList[3].contentList[2]"
                  class="box"
                  @click="toPage(detail.infoList[3].contentList[2])"
                >
                  <div style="width: 100%; height: 100%">
                    <img :src="casethree && casethree.caseCover || ''" alt="" />
                  </div>
                  <div class="dxal-title">{{ casethree && casethree.caseTitle || '' }}</div>
                </div>
              </el-col>
            </div>
            <!-- 功能模块 -->
            <div
              v-if="item.moduleName === '功能模块'"
              :id="`iddtail${item.moduleTitle}`"
            >
              <el-col
                v-for="(v, i) in item.contentList"
                :key="v.id"
                :xs="24"
                :md="11"
                style="margin-bottom: 20px"
              >
                <div style="margin-top: 10px" class="evenflow_scale">
                  <el-row :gutter="20">
                    <el-col :xs="8" :md="8" :lg="6" :xl="5">
                      <img
                        :src="v.picture"
                        style="width: 80px; min-height: 66px"
                      />
                    </el-col>
                    <el-col :xs="16" :md="14" :lg="16" :xl="17">
                      <label style="font-size: 18px; color: #131415">{{
                        v.subtitle
                      }}</label>
                      <div class="module-detail">{{ v.introduction }}</div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </div>
            <!-- 自定义模块 -->
            <div
              v-if="item.moduleName === '自定义模块' && item.contentList.length"
            >
              <el-col
                :span="24"
                v-for="(v, i) in item.contentList"
                :id="`iddtail${v.subtitle}`"
                :key="v.id"
                v-if="v.type"
              >
                <div
                  class="contant-title"
                  v-if="v.type === 'subtitle' && v.subtitle"
                >
                  <span></span>
                  <span>{{ v.subtitle }}</span>
                </div>
                <div
                  style="
                    line-height: 28px;
                    padding: 16px 0;
                    font-size: 18px;
                    color: #000;
                    font-weight: 500;
                  "
                  v-if="v.type === 'introduction' && v.introduction"
                >
                  {{ v.introduction }}
                </div>

                <div
                  v-if="v.type === 'picture' && v.picture"
                  style="width: 100%"
                >
                  <img :src="v.picture" style="width: 100%; margin: 25px 0" />
                </div>
                <div
                  v-if="v.type === 'video' && v.video"
                  style="width: 1000px; height: 562px; margin: 0 auto 50px auto"
                >
                  <video style="width: 100%" :src="v.video" muted loop controls>
                    <source type="video/mp4" :src="v.video" />
                  </video>
                </div>
              </el-col>
            </div>
          </el-row>
        </div>
      </div>
    </div>

    <!-- 产品咨询对话框 -->
    <consult
      v-if="open"
      :dialogVisible="open"
      @cancel="cancle"
      :productName="title"
      :isProduc="true"
      productId="0"
    >
    </consult>
    <div v-if="showButton" class="to-top" @click="totop()">
      <img src="../../assets/images/totop.png" alt="" />
    </div>
  </div>
</template>

<script>
import data from "./data";
import { detailProduct, detail } from "@/api";
export default {
  name: "ProductDetails",
  mixins: [data],
  data() {
    return {
          // 返回顶部按钮
          showButton: false,
      isNavFixed: false,
      open: false,
      title: undefined,
      mousein: false,
      list: [],
      lists: [],
      listerBg: undefined,
      detail: {},
      details: {},
      typeActive: 0,
      id: [],
      caseone: "",
      casetwo: "",
      casethree: "",
      titlelists: [],
    };
  },
  created() {
    this.getList();
  },
  beforeDestroy() {
    window.removeEventListener('scroll',  this.handleScroll);
    this.cleanupScriptAndClient();
  },
   mounted() {
  window.addEventListener('scroll',  this.handleScroll);
   },
  methods: {
    totop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 使滚动效果平滑
      });
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const topHeight = this.$el.querySelector('.top').offsetHeight;
      this.isNavFixed = scrollTop >= topHeight;
      this.showButton  = window.scrollY  > 200;
      console.log(scrollTop, "获取当前滚动的距离距离顶部多少像素");
    },
    changeTypeActive(index, item) {
      this.typeActive = index;
      this.$el.querySelector(`#iddtail${item}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "center",
      });
      // console.log(this.$el.querySelector(`#iddtail${item}`),111111111)
    },
    async getList() {
      const res = await detailProduct({ id: this.$route.query.id });
      this.detail = res.data;

      this.lists = res.data.infoList[2].contentList;

      res.data.infoList.forEach((t, i) => {
        if (i == 2) {
          this.lists.map((item) => {
            if (item.subtitle) {
              this.titlelists.push(item.subtitle);
            }
            // return this.titlelists;
          });
        } else {
          if (t.moduleTitle && t.moduleStatus === "1") {
            this.titlelists.push(t.moduleTitle);
          }
        }
      });

      for (let i = 0; i < res.data.infoList[3].contentList.length; i++) {
        this.id.push(res.data.infoList[3].contentList[i].linkInfo);
      }
      const res1 = await detail({ id: this.id[0] });
      this.caseone = res1.data;
      const res2 = await detail({ id: this.id[1] });
      this.casetwo = res2.data;
      const res3 = await detail({ id: this.id[2] });
      this.casethree = res3.data;
    },
    cancle(data) {
      this.open = data;
    },
    toSystem(url) {
      let jumpUrl = url;
      // const result = jumpUrl.match("login");
      const result = false;
      if (!result) {
        if (url !== "http://cwzx.eiiplat.com/taxPlan/index") {
          url = `${url}#/login`;
          window.open(
            url +
              (localStorage.usertoken ? `?token=${localStorage.usertoken}` : "")
          );
          console.log(url, 111);
        } else {
          window.open(
            url +
              (localStorage.usertoken
                ? `?token=${localStorage.usertoken}&userId=${localStorage.userId}`
                : "")
          );
        }
      }
    },
    toPage(item) {
      this.$router.push({
        path: "/solition_lower",
        query: { id: item.linkInfo },
      });
    },
    inMouse() {
      // 鼠标移入
      this.mousein = true;
    },
    outMouse() {
      this.mousein = false;
    },
    loadScriptAndInit() {
      // 如果已经加载过 Coze SDK，则不再重复加载
      if (window.CozeWebSDK && this.cozeClient) {
        this.initCozeChat();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://lf-cdn.coze.cn/obj/unpkg/flow-platform/chat-app-sdk/1.2.0-beta.10/libs/cn/index.js';
      script.async = true;
      script.onload = () => {
        console.log('Coze SDK 加载完成');
        this.initCozeChat();
      };
      script.onerror = () => {
        console.error('加载 Coze SDK 失败');
      };

      this.scriptElement = script;
      document.body.appendChild(script);
    },
    initCozeChat() {
      if (window.CozeWebSDK) {
        this.cozeClient = new window.CozeWebSDK.WebChatClient({
          config: {
            bot_id: '7520438431194103871',
          },
          componentProps: {
            title: 'Coze',
          },
          auth: {
            type: 'token',
            token: 'pat_xre20sUICnU2Zdeh46UrzrP3XELch8u3hdaCBUwPgXjEr0oNq5KKybFrNkRRJ4qr',
            onRefreshToken: function () {
              return 'pat_xre20sUICnU2Zdeh46UrzrP3XELch8u3hdaCBUwPgXjEr0oNq5KKybFrNkRRJ4qr'
            }
          }
        });
      } else {
        console.error('CozeWebSDK 未定义，请检查 SDK 是否正确加载');
      }
    },
    cleanupScriptAndClient() {
      // 销毁客户端实例（如果有 destroy 方法）
      if (this.cozeClient && typeof this.cozeClient.destroy === 'function') {
        this.cozeClient.destroy();
      }

      // 移除脚本标签
      if (this.scriptElement && this.scriptElement.parentNode) {
        this.scriptElement.parentNode.removeChild(this.scriptElement);
      }

      // 清理引用
      this.cozeClient = null;
      this.scriptElement = null;

      console.log('Coze SDK 已清理');
    }
  },
  watch: {
    "$route.query.id": {
      handler(id) {
        // 1673609014010001
        if(['1673608977010001', '1678253269010001', '1673609014010001'].includes(id)) {
          this.loadScriptAndInit();
        }else{
          this.cleanupScriptAndClient()
        }
        this.getList();
      },
      immediate: true,
    },
  }
};
</script>

<style lang="scss" scoped>
.to-top {
  cursor: pointer;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
  // border: 1px solid #ccc;
  position: fixed;
  z-index: 9999999;
  bottom: 100px;
  right: 100px;
  background-color: #fff;
  box-shadow: 0px 0px 8px 2px #ccc;
  img {
    width: 50%;
    height: 50%;
  }
}
.fixed {
  z-index: 999999;
  position: fixed;
    top: 60px;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
}
.dxal-box {
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  /* margin-right: 30px; */
  width: 100%;
}
.dxal-title {
  height: 47px;
  position: relative;
  bottom: 47px;
  text-align: center;
  color: #fff;
  background-color: #0006;
  width: 332px;
  line-height: 47px;
  font-size: 13px;
}
.active {
  color: #d7000f !important;
}
.inbutton {
  list-style: none;
  height: 37px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  transition: all 0.3s;

  &.inmouse {
    height: auto;

    li {
      transition: all 0.5s;

      &:not(:first-child) {
        opacity: 1;
      }
    }
  }

  li {
    transition: all 0.5s;

    &:not(:first-child) {
      width: 120px;
      height: 30px;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      border: 1px solid rgba(255, 255, 255, 0.6);
      opacity: 0;
      // display: none;
    }
  }
}

.details-banner {
  width: 100%;
  height: 450px;
  background: url("~@/assets/images/Rectangle.png") lightgray 0px 0px / 100%
    100% no-repeat;
  position: relative;

  .details-intro {
    width: 1280px;
    margin-left: -640px;
    position: absolute;
    top: 30%;
    left: 50%;
    color: #333;

    .title {
      font-size: 40px;
      font-weight: 500;
      margin-bottom: 16px;
    }

    .subtitle {
      font-size: 16px;
      color: #666;
      font-weight: 400;
      line-height: 28px;
      max-height: 112px;
      overflow: hidden;
      text-overflow: ellipsis; //超出文本设置为...
      display: -webkit-box; //将div1转换为盒子模型
      -webkit-line-clamp: 4; //设置div1的文本为2行
      -webkit-box-orient: vertical; //从顶部向底部垂直布置子元素
    }

    .btn {
      width: 136px;
      height: 44px;
      font-size: 14px;
      line-height: 44px;
      color: #fff;
      background: #e50009;
      text-align: center;
      cursor: pointer;
      border: 1px solid #e50009;
    }

    .btn1 {
      border: 1px solid #fff;
      background: #fff;
      box-shadow: 8px 8px 20px 0px rgba(55, 99, 170, 0.1),
        0px 4px 20px 1px rgba(255, 255, 255, 0.5) inset;
      width: 136px;
      height: 44px;
      font-size: 14px;
      line-height: 44px;
      text-align: center;
      cursor: pointer;
    }
  }
}

.details-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  min-height: 360px;

  .contant {
    width: 1280px;

    .item {
      /* margin-bottom: 50px; */
      .module-detail {
        font-size: 14px;
        color: #131415;
        opacity: 0.6;
        margin: 20px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        height: 38px;
      }
    }

    .contant-title {
      height: 45px;
      font-weight: 700;
      color: #000000;
      margin-top: 60px;
      margin-bottom: 60px;
      text-align: center;

      :first-child {
        width: 3px;
        height: 20px;
        background: #e50009;
        margin-right: 5px;
      }

      span {
        font-size: 30px;
        font-weight: 600;
      }
    }

    .card {
      box-shadow: 0rem 0.04rem 0.3rem 0rem rgba(204, 204, 204, 0.7);
      margin-bottom: 40px;
    }

    .box {
      cursor: pointer;
      margin-right: 30px;
      height: 200px;
      width: 332px;
      transition: all 0.5s;
      div:first-child {
        width: 100%;
        height: 100%;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .label {
        font-size: 40px;
        font-weight: 400;
        line-height: 60px;
        color: #131415;
      }

      .desc {
        font-size: 18px;
        font-weight: 400;
        line-height: 25px;
        color: #333333;
      }
    }

    .box:hover {
      // box-shadow: 16px 25px 16px -5px rgba(0, 0, 0, 0.3);

      // .label {
      //   color: #e50009;
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductDetails/index.vue